module.exports = __webpack_public_path__ + "static/media/ryans.c2e3f060.png";